import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    PrimaryButton,
} from 'components/buttons';
import {
    Card,
    Help,
} from 'components/other';

import AmountCard from './AmountCard/AmountCard';
import ProgressCard from './ProgressCard';
import WarningCard from './WarningCard';

import circleImage from './media/circle.svg';

import styles from './PendingStatusCard.module.scss';

const PendingStatusCard: FC<IProps> = (props) => {
    return (
        <Card className={classNames(styles.pendingStatusCard, props.className)}>
            <img
                className={styles.circleImage}
                src={circleImage}
                alt={'Pending'}
            />
            <div className={styles.title}>
                Payment in Process
            </div>
            <div className={styles.description}>
                We received your transaction. Checking usually takes 5–10 minutes.
            </div>
            <WarningCard className={styles.warningCard}/>
            <ProgressCard className={styles.progressCard}/>
            <AmountCard
                className={styles.amountCard}
                amountKopecks={props.amountKopecks}
                currencySymbol={props.currencySymbol}
            />
            <PrimaryButton
                className={styles.button}
                text={'Go to Merchant Site'}
                href={props.url}
            />
            <Help
                className={styles.help}
                text={'Need help? Contact merchant support.'}
            />
        </Card>
    );
};

export default PendingStatusCard;
